import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/landing-mobile.jpg'
import _imports_1 from '@/assets/images/landing-mobile@2x.jpg'
import _imports_2 from '@/assets/images/landing-desktop.jpg'
import _imports_3 from '@/assets/images/landing-desktop@2x.jpg'
import _imports_4 from '@/assets/images/landing-cloud.png'
import _imports_5 from '@/assets/images/landing-cloud@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-42ccffbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = _imports_0 + ' 1x, ' + _imports_1 + ' 2x'
const _hoisted_2 = _imports_2 + ' 1x, ' + _imports_3 + ' 2x'
const _hoisted_3 = _imports_4 + ' 1x, ' + _imports_5 + ' 2x'
const _hoisted_4 = _imports_4 + ' 1x, ' + _imports_5 + ' 2x'
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("picture", { class: "background" }, [
  /*#__PURE__*/_createElementVNode("source", {
    srcset: _hoisted_1,
    media: "(max-width: 1024px)"
  }),
  /*#__PURE__*/_createElementVNode("source", { srcset: _hoisted_2 }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "",
    loading: "lazy"
  })
], -1))
const _hoisted_6 = { class: "cloud cloud--1" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", { srcset: _hoisted_3 }, null, -1))
const _hoisted_8 = { class: "cloud cloud--2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", { srcset: _hoisted_4 }, null, -1))
const _hoisted_10 = { class: "landing__scroller" }
const _hoisted_11 = { class: "brand" }
const _hoisted_12 = { class: "brands-wrapper fade" }
const _hoisted_13 = { class: "nav__wrapper fade" }
const _hoisted_14 = { class: "nav" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "escape-path" }
const _hoisted_17 = ["width", "height", "viewBox"]
const _hoisted_18 = { id: "escape-path-mask--1" }
const _hoisted_19 = ["width", "height"]
const _hoisted_20 = ["d"]
const _hoisted_21 = ["d"]
const _hoisted_22 = ["d"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M10 7.12728L0 4.37114e-07L6.11959e-07 14L10 7.12728Z" }, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "footer-nav" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "A Meta WebXR production in association with FEMA and Ad Council -", -1))

import Tracking from "@/core/Tracking";
import gsap from "gsap";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { watch } from "vue";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import {
  ComponentPublicInstance,
  computed,
  nextTick,
  onMounted,
  onUnmounted,
  reactive,
  ref,
} from "vue";
import { useI18n } from "vue-i18n";
import { useAppState, useGameState } from "@/services/composition";

import UIBrands from "@/components/UIBrands/UIBrands.vue";
import AnimateSprite from "@/components/AnimateSprite/AnimateSprite.vue";
import UIAbout from "@/components/UIAbout/UIAbout.vue";
import UIInfo from "@/components/UIInfo/UIInfo.vue";
import Viewport from "@/store/modules/Viewport";
import { Role } from "@/services/states/AppStateMachine";
import UIPagePanel from "@/components/UIPagePanel/UIPagePanel.vue";
import type { pagePanelId } from "@/services/stores/page-panels";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

gsap.registerPlugin(DrawSVGPlugin);
gsap.registerPlugin(MotionPathPlugin);

const { t } = useI18n();
const { state, send } = useAppState();

const container = ref(null);
const landing = ref(null);
const logo = ref(null);
const informationBtn = ref(null);
const footer = ref(null);
// const sponsor = ref(null)

const blockCrossAnimation = ref(false);

const escapePathMask = ref(null);
const escapePathInvisible = ref(null);
const escapePathLine = ref(null);
const escapePathHead = ref(null);
const escapePathData = ref({
  viewBox: { minX: 0, minY: 0, width: 0, height: 0 },
  path: { d: "" },
  // mask: { x: 0, y: 0, height : 0, width: 0 }
});

let winW = 0;
let winH = 0;
const mouse = reactive({
  x: 0.5,
  y: 0.5,
});

let cloudLoops: Array<gsap.core.Timeline> = [];

const aboutOptions = ref({
  isOpen: false,
  x: 0,
  y: 0,
});
const infoOptions = ref({
  isOpen: false,
  x: 0,
  y: 0,
});

let onEnterTl: null | gsap.core.Timeline = null;
let isEntered = false;

onMounted(() => {
  window.addEventListener("resize", resize);
  window.addEventListener("mousemove", mousemove);

  resize();

  onEnter();
});

onUnmounted(() => {
  window.removeEventListener("resize", resize);
  window.removeEventListener("mousemove", mousemove);

  cloudLoops.forEach((loop) => {
    loop.kill();
  });
});

const startXP = () => {
  if (
    state.value.context.role === Role.Desktop ||
    state.value.context.role === Role.XR
  ) {
    send("START");
    return;
  }
  send({ type: "ROLE", data: Role.Desktop });
};

const startGuide = () => {
  if (state.value.context.role === Role.Desktop) {
    send({ type: "ROLE", data: Role.Companion });
    return;
  }
  send("START");
};

const mousemove = (e: MouseEvent) => {
  mouse.x = Math.round((e.pageX / winW) * 1000) / 1000;
  mouse.y = Math.round((e.pageY / winH) * 1000) / 1000;
};

const resize = async () => {
  winW = window.innerWidth;
  winH = window.innerHeight;

  await nextTick();
  const footerBCR = footer.value.getBoundingClientRect();
  // const sponsorBCR = sponsor.value.getBoundingClientRect()
  // const maxY = footerBCR.bottom - sponsorBCR.bottom + sponsorBCR.height * 0.5
  const maxY = Math.round(footerBCR.height) - 10;

  escapePathData.value = {
    viewBox: {
      minX: 0,
      minY: 0,
      width: Math.round(footerBCR.width) + 44 + 14,
      height: Math.round(footerBCR.height) + 56,
    },
    path: {
      d: `M9 56 V${56 + maxY} H${Math.round(footerBCR.width) + 49 - 58} L${
        Math.round(footerBCR.width) + 48
      } ${56 + maxY - 68} V${56 * 0.5 + 10} H${
        Math.round(footerBCR.width) + 48 - 28
      }`,
    },
    // mask: {
    //   x: (footerBCR.width - sponsorBCR.width) * 0.5,
    //   y: maxY - 10 + 56,
    //   height : 20,
    //   width: sponsorBCR.width
    // }
  };

  if (isEntered) {
    await nextTick();
    onEnter();
  }
};

const pagePanelSlug = computed(() => {
  return state.value.context.pagePanelId || null;
});

watch(pagePanelSlug, (show) => {
  if (show) {
    gsap.to(container.value, { opacity: 0, duration: 0.3, ease: "quint.out" });
  } else {
    gsap.to(container.value, { opacity: 1, duration: 0.3, ease: "quint.out" });
  }
});

const onEnter = () => {
  const path = escapePathMask.value as SVGPathElement;
  const head = escapePathHead.value as SVGGElement;

  let progress = 0;
  if (onEnterTl) {
    progress = onEnterTl.progress();
    onEnterTl.kill();
  }

  cloudLoops.forEach((loop) => {
    loop.kill();
  });

  const $ = gsap.utils.selector(landing.value);

  onEnterTl = gsap
    .timeline({
      onComplete: () => {
        if (!isEntered) {
          isEntered = true;
          displayInfo();
        }
      },
    })
    .addLabel("escapePath", 0.5);

  if (Viewport.windowWidth >= 1000) {
    onEnterTl
      .set(
        [$(".fade")],
        {
          clearProps: "opacity",
        },
        0
      )

      // ESCAPE PATH
      // .to( head, {
      //     motionPath: {
      //       path: path,
      //       align: path,
      //       alignOrigin: [0.5, 0.5],
      //       autoRotate: true,
      //     },
      //     duration: 2.5,
      //     ease: 'quart.inOut',
      //   },
      //   'escapePath'
      // )

      .fromTo(
        path,
        {
          drawSVG: "0 100%",
        },
        {
          drawSVG: "100% 100%",
          duration: 2.5,
          ease: "quart.inOut",
        },
        "escapePath"
      )

      .to(
        head,
        {
          motionPath: {
            path: escapePathInvisible.value,
            align: escapePathInvisible.value,
            alignOrigin: [0.5, 0.5],
            autoRotate: true,
          },
          duration: 2.5,
          ease: "quart.inOut",
        },
        "escapePath"
      )

      .fromTo(
        [...$(".escape-path")],
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 1,
          ease: "none",
        },
        "escapePath+=0.6"
      )

      .fromTo(
        [...$(".brands")],
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 0.5,
          ease: "quart.out",
        },
        "escapePath+=0.4"
      )

      // SPONSOR
      // .fromTo([$('.supported-by')], {
      //     opacity: 0
      //   }, {
      //     opacity: 1,
      //     duration: 0.5,
      //     ease: 'quart.out'
      //   },
      //   'escapePath+=1.15'
      // )

      // BUTTONS
      .fromTo(
        [$(".nav")],
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 1,
          ease: "none",
        },
        "escapePath+=0.5"
      )
      .fromTo(
        [$(".btn-nav-infos")],
        {
          yPercent: 100,
        },
        {
          yPercent: 0,
          duration: 1,
          ease: "quart.out",
        },
        "escapePath+=0.5"
      )
      .fromTo(
        [$(".btn-start-xp, .btn-start-start-guide")],
        {
          yPercent: 200,
        },
        {
          yPercent: 0,
          duration: 1,
          ease: "quart.out",
        },
        "escapePath+=0.5"
      )
      .fromTo(
        [$(".nav__paragraph")],
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 1,
          ease: "none",
        },
        "escapePath+=1"
      )

      // BACKGROUND
      .fromTo(
        [$(".background img")],
        {
          scale: 1.2,
          rotate: 5,
          immediateRender: true,
        },
        {
          scale: 1,
          rotate: 0,
          duration: 3,
          ease: "quart.out",
        },
        0
      )

      // CLOUDS
      .fromTo(
        [$(".cloud")],
        {
          xPercent: gsap.utils.wrap([-5, 10]),
        },
        {
          xPercent: 0,
          duration: 3,
          ease: "quart.out",
          onComplete: () => {
            if (Viewport.isDesktop) {
              cloudLoops = [];

              $(".cloud").forEach((cloud) => {
                cloudLoops.push(
                  gsap
                    .timeline({ repeat: -1, yoyo: true, repeatRefresh: true })
                    .to(
                      cloud,
                      {
                        x: gsap.utils.random(40, 80),
                        duration: gsap.utils.random(3, 4),
                        ease: "sine.inOut",
                      },
                      0
                    )
                );
                cloudLoops.push(
                  gsap
                    .timeline({ repeat: -1, yoyo: true, repeatRefresh: true })
                    .to(
                      cloud,
                      {
                        y: gsap.utils.random(20, -40),
                        duration: gsap.utils.random(2, 3),
                        ease: "sine.inOut",
                      },
                      0
                    )
                );
              });
            }
          },
        },
        0
      );
  } else {
    onEnterTl.fromTo(
      [$(".fade")],
      {
        opacity: 0.01,
      },
      {
        opacity: 1,
        duration: 1,
        ease: "none",
      },
      "escapePath+=1"
    );
  }

  // SET PROGRESS
  onEnterTl
    // LOGO
    .fromTo(
      [$(".brand-logo")],
      {
        opacity: 0,
        immediateRender: true,
      },
      {
        opacity: 1,
        duration: 0.01,
      },
      "escapePath"
    )
    .add(() => {
      if (progress === 0) {
        (logo.value as ComponentPublicInstance<typeof AnimateSprite>).animate();
      }
    }, "escapePath")

    .progress(progress);
};

const displayAbout = (e: Event) => {
  Tracking.about();
  blockCrossAnimation.value = true;
  const { x, y, width, height } =
    informationBtn.value.$el.getBoundingClientRect();
  gsap.to(container.value, {
    opacity: 0,
    duration: 0.3,
    ease: "power2.in",
  });
  aboutOptions.value = {
    isOpen: true,
    x: window.innerWidth / 2,
    y: window.innerHeight / 2,
  };
};

const closeAbout = () => {
  gsap.to(container.value, {
    opacity: 1,
    duration: 0.3,
    ease: "power2.in",
  });
  aboutOptions.value = {
    isOpen: false,
    x: 0,
    y: 0,
  };
  blockCrossAnimation.value = false;
};

const displayInfo = () => {
  blockCrossAnimation.value = true;
  const { x, y, width, height } =
    informationBtn.value.$el.getBoundingClientRect();
  gsap.to(container.value, {
    opacity: 0,
    duration: 0.3,
    ease: "power2.in",
  });
  infoOptions.value = {
    isOpen: true,
    x: window.innerWidth / 2,
    y: window.innerHeight / 2,
  };
};

const closeInfo = () => {
  Tracking.importantInformation();
  gsap.to(container.value, {
    opacity: 1,
    duration: 0.3,
    ease: "power2.in",
  });
  infoOptions.value = {
    isOpen: false,
    x: 0,
    y: 0,
  };
  blockCrossAnimation.value = false;
};

const rootClass = computed(() => {
  return {
    xr: state.value.context.role === Role.XR,
    companion: state.value.context.role === Role.Companion,
    desktop: state.value.context.role === Role.Desktop,
  };
});

return (_ctx: any,_cache: any) => {
  const _component_ui_btn_icon = _resolveComponent("ui-btn-icon")!
  const _component_ui_btn = _resolveComponent("ui-btn")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "long-fade",
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["landing", _unref(rootClass)]),
        ref_key: "landing",
        ref: landing
      }, [
        _createVNode(UIAbout, {
          isAnimationBlocked: true,
          aboutOptions: aboutOptions.value,
          onCloseAbout: closeAbout
        }, null, 8, ["aboutOptions"]),
        _createVNode(UIInfo, {
          isAnimationBlocked: true,
          infoOptions: infoOptions.value,
          onCloseInfo: closeInfo
        }, null, 8, ["infoOptions"]),
        _hoisted_5,
        _createElementVNode("div", null, [
          _createElementVNode("picture", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("img", {
              style: _normalizeStyle(`transform: translate3d(${_unref(mouse).x * 20}px, ${
              (1 - _unref(mouse).y) * 40
            }px, 0)`),
              src: _imports_4,
              alt: "",
              loading: "lazy"
            }, null, 4)
          ]),
          _createElementVNode("picture", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("img", {
              style: _normalizeStyle(`transform: translate3d(${_unref(mouse).x * -40}px, ${
              (1 - _unref(mouse).y) * -80
            }px, 0)`),
              src: _imports_4,
              alt: "",
              loading: "lazy"
            }, null, 4)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", {
            ref_key: "container",
            ref: container,
            class: "landing__inner"
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(UIBrands, { class: "brands--loading" }),
                _createVNode(_component_ui_btn_icon, {
                  class: "btn-sticky-infos",
                  variant: "secondary",
                  name: "infos",
                  onClick: displayAbout
                })
              ]),
              _createVNode(AnimateSprite, {
                ref_key: "logo",
                ref: logo,
                class: "brand-logo",
                path: "escape-plan",
                frames: 105,
                autoplay: false,
                loop: false,
                "aria-label": "Escape Plan"
              }, null, 512)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_ui_btn_icon, {
                  ref_key: "informationBtn",
                  ref: informationBtn,
                  isAnimationBlocked: blockCrossAnimation.value,
                  onClick: displayAbout,
                  class: "btn-nav-infos",
                  variant: "secondary",
                  name: "infos"
                }, null, 8, ["isAnimationBlocked"]),
                _createVNode(_component_ui_btn, {
                  class: "btn-start-xp",
                  onClick: startXP
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("landing.desktop.start")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ui_btn, {
                  class: "btn-start-guide",
                  variant: "secondary",
                  "border-position": "bottom-right",
                  onClick: startGuide
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("landing.companion.start")), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("p", {
                class: "nav__paragraph text-body text-small",
                innerHTML: _unref(t)('landing.paragraph')
              }, null, 8, _hoisted_15)
            ]),
            _createElementVNode("div", {
              ref_key: "footer",
              ref: footer,
              class: "footer fade"
            }, [
              _createElementVNode("div", _hoisted_16, [
                (_openBlock(), _createElementBlock("svg", {
                  id: "escape-path",
                  width: escapePathData.value.viewBox.width,
                  height: escapePathData.value.viewBox.height,
                  viewBox: `${escapePathData.value.viewBox.minX} ${escapePathData.value.viewBox.minY} ${escapePathData.value.viewBox.width} ${escapePathData.value.viewBox.height}`,
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("defs", null, [
                    _createElementVNode("mask", _hoisted_18, [
                      _createElementVNode("rect", {
                        x: "0",
                        y: "0",
                        width: escapePathData.value.viewBox.width,
                        height: escapePathData.value.viewBox.height,
                        fill: "white"
                      }, null, 8, _hoisted_19),
                      _createElementVNode("path", {
                        ref_key: "escapePathMask",
                        ref: escapePathMask,
                        d: escapePathData.value.path.d,
                        fill: "none",
                        "stroke-width": "4",
                        stroke: "black"
                      }, null, 8, _hoisted_20)
                    ])
                  ]),
                  _createElementVNode("path", {
                    ref_key: "escapePathInvisible",
                    ref: escapePathInvisible,
                    d: escapePathData.value.path.d,
                    fill: "none",
                    "stroke-width": "4",
                    stroke: "none"
                  }, null, 8, _hoisted_21),
                  _createElementVNode("path", {
                    mask: "url(#escape-path-mask--1)",
                    class: "dashed",
                    ref_key: "escapePathLine",
                    ref: escapePathLine,
                    d: escapePathData.value.path.d,
                    fill: "none",
                    "stroke-width": "2"
                  }, null, 8, _hoisted_22),
                  _createElementVNode("g", {
                    ref_key: "escapePathHead",
                    ref: escapePathHead
                  }, _hoisted_24, 512)
                ], 8, _hoisted_17))
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("a", {
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => {
                  _unref(send)({ type: 'SET_PAGE_PANEL', id: 'cookies' });
                  _unref(Tracking).cookies();
                }, ["prevent"])),
                  href: "#cookies_policy"
                }, _toDisplayString(_unref(t)("landing.footer_nav.cookies_policy")), 1),
                _createElementVNode("a", {
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => {
                  _unref(send)({ type: 'SET_PAGE_PANEL', id: 'privacy' });
                  _unref(Tracking).privacy();
                }, ["prevent"])),
                  href: "#privacy_policy"
                }, _toDisplayString(_unref(t)("landing.footer_nav.privacy_policy")), 1)
              ])
            ], 512)
          ], 512)
        ]),
        (_unref(pagePanelSlug))
          ? (_openBlock(), _createBlock(UIPagePanel, {
              key: _unref(pagePanelSlug),
              onClose: _cache[2] || (_cache[2] = ($event: any) => (_unref(send)({ type: 'SET_PAGE_PANEL', id: null }))),
              onRedirect: _cache[3] || (_cache[3] = (slug) => _unref(send)({ type: 'SET_PAGE_PANEL', id: slug }))
            }))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 1
  }))
}
}

})